import usePermissionByAccount from "./permission-by-account"

const { getNavigationList } = usePermissionByAccount()

const renderNavByPermission = () => {
  return getNavigationList
};

export default renderNavByPermission();
